import { useState } from 'react';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import Tooltip from './Tooltip';
import Modal from './Modal';

/**
 * @param {object} props
 * @param {React.ReactNode} props.content - Body rendered inside the modal
 * @param {string} [props.label] - Tooltip text on the icon and modal page header
 */
const InfoPopover = ({ content, label = 'Details' }) => {
    const [isOpen, setIsOpen] = useState(false);

    const open = (e) => {
        e.stopPropagation();
        setIsOpen(true);
    };

    return (
        <>
            <div className="info-popover-container">
                <Tooltip content={label} top="30px" width="20px">
                    <InfoOutlinedIcon
                        className="info-popover-icon"
                        fontSize="small"
                        onClick={open}
                    />
                </Tooltip>
            </div>
            <Modal
                modalOpen={isOpen}
                setModalOpen={setIsOpen}
                pageHeader={label}
                content={content}
                actions={null}
            />
        </>
    );
};

export default InfoPopover;
